module.exports = __webpack_public_path__ + "img/icon_user_remove.4f1cc21.svg";